<template>
  <div class="competitions">
    <select multiple @change="$emit('change', $event)">
      <optgroup v-for="group in items" :label="group.name" :key="group.name">
        <option v-for="item in group.competitions" :key="item.id" :value="item.id"  :title="item.nameFr+' ['+item.id+']'">{{ name(item) }}</option>
      </optgroup>
    </select>
  </div>
</template>

<script>
export default {
  name: 'SportGamesFiltersCompetitionCompetitions',
  computed: {
    items () {
      let datas = this.$store.getters['Sport/Competition/list']
      const filter = this.$store.getters['Sport/Competition/filtered']
      if (filter.length > 0) {
        datas = datas.filter(item => filter.indexOf(item.id) > -1)
      }

      const values = []
      for (const index in datas) {
        const data = datas[index]
        const sport = this.$store.getters['Sport/Sport/get'](data.sportId)
        const groupName = sport ? sport.name : '-- Multisports --'
        const key = values.findIndex(item => item.name === groupName)
        if (key > -1) {
          values[key].competitions.push(data)
        } else {
          const item = { name: groupName, competitions: [data] }
          values.push(item)
        }
      }
      values.sort((a, b) => a.name.localeCompare(b.name))
      return values
    }
  },
  methods: {
    name (item) { return item.provider ? '[' + item.provider.name + '] ' + item.nameFr : item.nameFr }
  }
}
</script>

<style scoped>
  .competitions{
    display:flex;
    align-items:center
  }
  .competitions > span{
    font-size:14px
  }
  .competitions > select{
    height:170px;
    flex:0 0 100%
  }
</style>
